import {takeEvery,all,put,select,call} from 'redux-saga/effects';
import * as actions from './actions';
import * as selectors from './selectors';
import * as fileAvailabilityApi from '../../api/fileAvailabilityApi';
import { searchToFilters } from '../../common/urlUtils';
import actionFactory from '../../webcommon/header/filterheader/actions';
import * as filterHeaderSelectors from '../../webcommon/header/filterheader/selectors';

const filterHeaderId = 'FileAvailability';

export const filterHeaderActions = actionFactory(filterHeaderId);

export function* fileAvailabilityConnected(action){
    try {
        const initialised = yield (select(selectors.getFileAvailabilityInitialised));
        if (!initialised) {
            yield put(actions.setFileAvailabilityLoading(true));
            const filterDefinitions = yield select(selectors.getFilterDefinitions);
            yield put(filterHeaderActions.setFilterDefinitions(filterDefinitions));
            const defaultFilters = yield select(selectors.getDefaultFilters);
            yield put(filterHeaderActions.setDefaultFilters(defaultFilters));
            if (action.search === '') {
                yield put(filterHeaderActions.resetFilters());
            } else {
                const filters = searchToFilters(action.search, filterDefinitions, defaultFilters);
                yield put(filterHeaderActions.setFilters(filters));
            }
            yield put(actions.getFileAvailability())

            yield put(actions.setFileAvailabilityInitialised(true));
        }
    } finally {
        yield put(actions.setFileAvailabilityLoading(false));
    }
}

export function* filterChanged(action) {
    const initialised = yield select(selectors.getFileAvailabilityInitialised);
    if (initialised) {
        const currentlyOpenFilter = yield (select(filterHeaderSelectors.getCurrentlyOpenFilter, filterHeaderId));
        if (!currentlyOpenFilter) {
            const filters = yield select(filterHeaderSelectors.getFilters, filterHeaderId);
            yield put(actions.setDateFrom(filters[0].value.from));
            yield put(actions.setDateTo(filters[0].value.to));
            yield put(actions.refreshFileAvailability());
        }
    }
} 

export function* getFileAvailability(api, action) {
    try {
        const filters = yield select(filterHeaderSelectors.getFilters, filterHeaderId);
        const result = yield call(api.getFileAvailability, filters)
        yield put(actions.getFileAvailabilitySuccess(result))
    } catch (error) {
        yield put(actions.getFileAvailabilityFailed('Failed to retrieve files from Database'));
    }
}





export default function* rootSaga() {
    yield all([
        takeEvery(actions.FILE_AVAILABILITY_LOADED, fileAvailabilityConnected),
        takeEvery(
            [
                filterHeaderActions.UPDATE_FILTER,
                filterHeaderActions.REMOVE_FILTER,
                filterHeaderActions.RESET_FILTERS
            ], 
            filterChanged),
        takeEvery(
            [
                actions.GET_FILE_AVAILABILITY, 
                actions.REFRESH_FILE_AVAILABILITY
            ],
            getFileAvailability, fileAvailabilityApi),
    ]);
}